export const FILE_TYPE = {
    PNG: 'image/png',
    JPEG: 'image/jpeg',
    JPG: 'image/jpg',
    SVG: 'image/svg',
    GIF: 'image/gif',
    RAW: 'image/raw',
    DOC: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    PDF: 'application/pdf',
    EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    CSV: 'text/csv',
    PPT: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    TXT: 'text/plain',
    HTML: 'text/html',
    ZIP: 'application/zip',
    RAR: 'application/vnd.rar'
}